module.exports = __webpack_public_path__ + "img/RDD.d650c488.svg";